import { CampaignLayout, InGameCampaignNavigation } from "./campaign-layout";
import { useEffect } from "react";
import { useStoreWithEqualityFn } from "zustand/traditional";

import { CampaignNotFound } from "./campaign-not-found";
import { useAppStore } from "@/stores";
import { resolveEffectiveCampaignKey } from "@/campaigns";
import { useHasCurrentCampaign } from "@/hooks/use-current-campaign";
import { useClearDanglingSelection } from "@/hooks/use-clear-dangling-selection";

/**
 * Renders campaign views when a campaign is selected (from config or user choice).
 * Selected campaign comes from store, not from route params (embed-friendly).
 */
export const CampaignWrapper = () => {
  // Existence only: subscribing to the whole campaign re-rendered this gate — and the entire page
  // under it — on every progress push.
  const hasCurrent = useHasCurrentCampaign();
  useClearDanglingSelection();

  if (!hasCurrent) {
    return <CampaignNotFound />;
  }

  return <CampaignLayout />;
};

export const InGameCampaignWrapper = () => {
  // Existence only: subscribing to the whole campaign re-rendered this gate — and the entire page
  // under it — on every progress push.
  const hasCurrent = useHasCurrentCampaign();
  const selectedCampaignId = useAppStore((s) => s.selectedCampaignId);
  const setSelectedCampaignId = useAppStore((s) => s.setSelectedCampaignId);

  useClearDanglingSelection();

  // Auto-select on open so the view has a campaign to render (the button resolves
  // one via its own fallback, but the view reads only selectedCampaignId). The
  // registry decides the first campaign across every type — no per-type branch.
  const effectiveKey = useStoreWithEqualityFn(
    useAppStore,
    (s) => resolveEffectiveCampaignKey(s, s.selectedCampaignId),
    Object.is
  );
  useEffect(() => {
    if (!selectedCampaignId && effectiveKey) {
      setSelectedCampaignId(effectiveKey);
    }
  }, [selectedCampaignId, effectiveKey, setSelectedCampaignId]);

  if (!hasCurrent) {
    return <CampaignNotFound />;
  }

  return <InGameCampaignNavigation />;
};
